import SnackbarComponent from "./SnackbarComponent"

export default SnackbarComponent
